import React from 'react'
import { useIntl } from 'react-intl'
import { Dialog } from 'primereact/dialog'
import { LuxDataTable } from '@lux/wardrobe-lib'
import './DialogStoreList.scss'
import { columns } from './table-config'
import { StoreProps } from '@/app/models/store'

const DialogStoreList = (props: {
    dialogVisible: boolean
    onHide: () => void
    storesList: StoreProps[]
}) => {
    const { dialogVisible, onHide, storesList } = props

    const componentClass = 'smart-modals-dialog-store-list'

    const intl = useIntl()

    return (
        <Dialog
            header={intl.formatMessage({
                id: 'storeList',
                defaultMessage: 'Store list',
            })}
            draggable={false}
            visible={dialogVisible}
            onHide={() => onHide()}
            style={{ width: '80vw' }}
            maskClassName={componentClass}
            breakpoints={{ '960px': '85vw' }}>
            <div className={`${componentClass}-content`}>
                <div className={`${componentClass}-content-store-list`}>
                    <LuxDataTable
                        columns={columns.map((column) => ({
                            ...column,
                            header: intl.formatMessage({
                                id: column.header,
                                defaultMessage: column.header.split('.').pop(),
                            }),
                        }))}
                        dataSet={storesList}
                        scrollable
                        totalRecords={0}
                        columnFilters={{}}
                        labels={{
                            filter: intl.formatMessage({
                                id: 'modals.new_resource.distribution.store_list.filter',
                                defaultMessage: 'filter',
                            }),
                            rearrange: intl.formatMessage({
                                id: 'modals.new_resource.distribution.store_list.rearrange',
                                defaultMessage: 'rearrange',
                            }),
                            of: intl.formatMessage({
                                id: 'modals.new_resource.distribution.store_list.labels.of',
                                defaultMessage: 'of',
                            }),
                            selected: intl.formatMessage({
                                id: 'modals.new_resource.distribution.store_list.labels.selected',
                                defaultMessage: 'selected',
                            }),
                            emptyMessage: intl.formatMessage({
                                id: 'modals.new_resource.distribution.store_list.labels.emptyMessage',
                                defaultMessage: 'No results to show.',
                            }),
                        }}
                    />
                </div>
            </div>
        </Dialog>
    )
}

export default DialogStoreList
